import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getOfferingByOfferingId, getVersionDetailsData } from "../services/hc_apis";
import Header from "./Header";
import "./Offering.css";
import SignupModal from './SignupModal';

const Offering = () => {
  const { offeringId } = useParams();
  const navigate = useNavigate();
  const [offering, setOffering] = useState(null);
  const [version, setVersion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showSignupModal, setShowSignupModal] = useState(false);

  useEffect(() => {
    if (offeringId) {
      fetchOffering();
    }
    getVersionDetails();
  }, [offeringId]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchOffering = async () => {
    try {
      setLoading(true);
      const result = await getOfferingByOfferingId(offeringId);
      if (result.status === 200 && result.data.status === 200) {
        setOffering(result.data.data);
      } else {
        setError("Offering not found");
      }
    } catch (err) {
      setError("Failed to load offering");
      console.error("Error fetching offering:", err);
    } finally {
      setLoading(false);
    }
  };

  const getVersionDetails = async () => {
    const result = await getVersionDetailsData();
    if (result.status === 200) {
      setVersion(result?.data?.data);
    } else {
      setVersion(null);
    }
  };

  if (loading) {
    return (
      <>
        {/* <Header group={null} version={version} /> */}
        <div className="offering-loading-wrapper">
          <div className="offering-loading">
            <div className="offering-spinner"></div>
            <p>Loading offering...</p>
          </div>
        </div>
      </>
    );
  }

  if (error || !offering) {
    return (
      <>
        {/* <Header group={null} version={version} /> */}
        <div className="offering-error-wrapper">
          <div className="offering-error">
            <h2>Offering Not Found</h2>
            <p>{error || "The offering you're looking for doesn't exist."}</p>
            <button onClick={() => navigate("/")} className="offering-home-button">
              Go Home
            </button>
          </div>
        </div>
      </>
    );
  }

  const userGroup = offering.user_group_id || null;

  return (
    <>      
      <div className="offering-page-container">
        {/* Left Column - Offering Details */}
        <div className="offering-left-column">
          <div className="offering-hero-section">
            <div className="offering-hero-content">
              <h1 className="offering-hero-title">{offering.title}</h1>
              <div className="offering-badge">
                {offering.created_by_user_id && offering.created_by_user_id.name && (
                  <span className="offering-badge-text" style={{ marginLeft: '0px' }}>
                    By {offering.created_by_user_id.name}
                  </span>
                )}
              </div>
            </div>
          </div>

          {offering.cover_image && (
            <div className="offering-image-section">
              <div className="offering-image-container">
                <img
                  src={offering.cover_image}
                  alt={offering.title}
                  className="offering-cover-image"
                />
              </div>
            </div>
          )}

          {offering.description && (
            <div className="offering-description-section">
              <div
                className="offering-description"
                dangerouslySetInnerHTML={{ __html: offering.description }}
              />
            </div>
          )}
        </div>

        {/* Right Column - Payment Details (Desktop only) */}
        {!isMobile && (
          <div className="offering-right-column">
            <SignupModal
              onClose={() => {}}
              group={userGroup}
              version={version}
              renderAsPage={true}
              service={offering}
            />
          </div>
        )}
      </div>

      {/* Mobile Sticky Button */}
      {isMobile && offering && offering.price !== undefined && (
        <div className="offering-mobile-sticky-button">
          <button
            className="offering-mobile-cta-button"
            onClick={() => setShowSignupModal(true)}
          >
            Next
          </button>
        </div>
      )}

      {/* Mobile Signup Modal */}
      {isMobile && showSignupModal && (
        <SignupModal
          onClose={() => setShowSignupModal(false)}
          group={userGroup}
          version={version}
          renderAsPage={false}
          service={offering}
        />
      )}

      <div className="offering-footer">
        <span className="copyright_text">
          &copy; 2026 HEARTFUL TECH Pvt Ltd.
        </span>
      </div>
    </>
  );
};

export default Offering;
